import React, { useContext, useState, useEffect, useRef } from "react";
import SidebarContext from "../../contexts/MyContext";
import Button from "../../components/button/button";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import Modal from "../Modal/Modal";
import { truncateFileName } from "../../utils/truncateFileName";
import { errorToast } from "../../utils/notificationUtils";
import axios from "axios";
import { formatTimeWithOptionalHours, durationToSeconds } from "../../utils/timeFile";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import { Icon } from "@iconify/react";
import "../../css/app/editTools.css";


const MergeRecordingLogic = () => {
    const { selectMergeAudio, setSelectMergeAudio, setTabIndex, filterAudioData, setFilterAudioData, setActionTabIndex, actionTabIndex, setAudio } = useContext(SidebarContext);
    const [openModal, setOpenModal] = useState(false);
    const [recordingName, setRecordingName] = useState("")
    const [loading, setLoading] = useState(false)

    const cancelTokenSourceRef = useRef(null);
    const maxLength = 100; // Define the maximum length





    const handleClose = () => {
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel('Operation canceled by the user.');
        }
        setOpenModal(false);
        setRecordingName('')
    };

    const doHandleRemoveSelectedMergeAudio = (event, id) => {
        event.preventDefault();
        const updatedSelectedMergeAudio = selectMergeAudio.filter(
            (el) => el._id !== id
        );
        setSelectMergeAudio(updatedSelectedMergeAudio);

    };

    const handalMergeAudio = async (e) => {
        const randomAudioName = `Merged${generateRandomNumber()}`;
        e.preventDefault();
        // Abort any ongoing requests
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel('Operation canceled by the user.');
        }

        // Create a new CancelToken source
        cancelTokenSourceRef.current = axios.CancelToken.source();
        // console.log(cancelTokenSourceRef.current, 'cancelTokenSourceRef.current')
        const mergeRecordingName = randomAudioName.trim();

        try {
            setLoading(true)
            // Extract folderIds, filter out empty values, and remove duplicates using Set
            const uniqueFolderIds = [...new Set(selectMergeAudio.map((e) => e?.folderId || e.audio?.folderId).filter(id => id))];

            // Get the first unique folderId or set it to an empty string if none exist
            const folderId = uniqueFolderIds.length > 0 ? uniqueFolderIds[0] : '';
            const payload = {
                recordings: selectMergeAudio?.map((e) => e.audio),
                audioName: mergeRecordingName,
                action: 'Merge'
            }
            const data = await AudioHandler.doHandalMergeAudio(payload, cancelTokenSourceRef.current.token, folderId)
            // console.log(!axios.isCancel(data), '!axios.isCancel(data)')
            if (!axios.isCancel(data)) {
                if (data?.statusCode === 200) {
                    // console.log(data, 'merge data')
                    setSelectMergeAudio([]);
                    setFilterAudioData([data?.data, ...filterAudioData]);
                    setOpenModal(false);
                    setRecordingName('');
                    setLoading(false);
                    setActionTabIndex(null);
                    setAudio()
                } else {
                    console.log(data, 'error')
                    const errorMessage =
                        data?.response?.data?.error || data?.response?.data?.message || data?.message || data?.error || "An error occurred";
                    errorToast(errorMessage);
                    setLoading(false);


                }
            }
        } catch (error) {
            console.log(axios.isCancel(error), 'axios.isCancel(error)')
            if (axios.isCancel(error)) {
                console.log('Request was canceled');
            } else {
                console.log('Request failed', error);
                // errorToast('An error occurred');
                const errorMessage =
                    error?.response?.data?.error || error?.response?.data?.message || error?.message || error?.error || "An error occurred";
                errorToast(errorMessage);
            }
        } finally {
            setLoading(false);
            cancelTokenSourceRef.current = null;
        }
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // Limit the length of the input value
        if (inputValue.length <= maxLength) {
            setRecordingName(inputValue);
        }
    };

    return (
        <div className="vr-edit vr-tone-violet">

            {selectMergeAudio.length == 0 ? (
                <div className="vr-edit-empty">
                    <img src="/img/merge/merge_img.png" />
                    <h3>
                        Select Recording for Merge
                    </h3>
                    <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's
                    </p>
                </div>
            ) : (
                <>
                    <div className="vr-edit-head">
                        <span className="vr-icon-tile is-solid"><Icon icon="lucide:merge" width={20} height={20} /></span>
                        <div className="vr-edit-head-text">
                            <h6 className="vr-edit-title">
                                Merge
                            </h6>
                        </div>
                        <button type="button" className="vr-iconbtn is-bordered vr-edit-close" aria-label="Close" onClick={(e) => { setActionTabIndex(null) }}>
                            <Icon icon="lucide:x" width={18} height={18} />
                        </button>
                    </div>
                    <div className="vr-edit-card vr-edit-listcard">
                        <div className="vr-edit-list vr-stagger">
                            {selectMergeAudio.map((e, index) => {
                                return (
                                    <>

                                        <div className="vr-edit-rowwrap" key={index}>
                                            <div className="vr-edit-row">
                                                <span className="vr-edit-num">{index + 1}</span>
                                                <span className="vr-edit-row-icon">
                                                    <Icon icon="lucide:audio-lines" width={18} height={18} />
                                                </span>
                                                <div className="vr-edit-row-name">
                                                    <h6>
                                                        {truncateFileName(e?.audio?.fileName, 30)}
                                                    </h6>
                                                    {/* <div className="d-flex" style={{ alignItems: "center" }}>
                                                    <p
                                                        style={{
                                                            marginBottom: "0",
                                                            color: "#94A3B8",
                                                            marginRight: "10px",
                                                            fontSize: "12px",
                                                        }}
                                                    >

                                                        {formatTimeWithOptionalHours(durationToSeconds(e?.audio?.timeDuration))}
                                                    </p>
                                                    <p
                                                        style={{
                                                            background: "#F1F5F9",
                                                            color: "#94A3B8",
                                                            borderRadius: "5px",
                                                            padding: "1px 4px",
                                                            fontSize: "12px",
                                                            marginBottom: "0",
                                                        }}
                                                    >
                                                        {e.audio.fileName?.includes('.')
                                                            ? e.audio.fileName.slice(e.audio.fileName.lastIndexOf('.') + 1)
                                                            : ''}

                                                    </p>
                                                </div> */}
                                                </div>
                                                <button
                                                    className="vr-btn vr-btn-secondary vr-btn-sm vr-edit-remove"
                                                    onClick={(event) => {
                                                        doHandleRemoveSelectedMergeAudio(event, e._id);
                                                    }}
                                                >
                                                    <Icon icon="lucide:x" width={14} height={14} />
                                                    Remove
                                                </button>
                                                {/* <Button
                                            btnText={"Remove"}
                                            primary
                                            onClick={(event) => {
                                                doHandleRemoveSelectedMergeAudio(event, e._id);
                                            }}
                                        /> */}
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}
            <div className="vr-edit-foot">
                {selectMergeAudio.length >= 2 ? (
                    <button
                        className="vr-btn vr-btn-primary"
                        // onClick={() => setOpenModal(true)}
                        onClick={(e) => {
                            handalMergeAudio(e);
                        }}
                    >
                        <Icon icon="lucide:download" width={18} height={18} />
                        <span>


                            {loading ? (
                                <>
                                    <div
                                        className="spinner-border"
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span>
                                        Save
                                    </span>
                                </>
                            )
                            }
                        </span>
                    </button>
                ) : (
                    <></>
                )}
            </div>
            {openModal && (
                <Modal
                    onClose={() => handleClose()}
                    modaltxt={"Save recording"}
                    closeButtonDisabled={loading}
                >
                    <div className="vr-edit-modal">
                        <div className="form-group">
                            <input
                                type="text"
                                className="vr-input input-field"
                                id="recordingname"
                                name="recordingname"
                                placeholder="Recording name"
                                value={recordingName}
                                onChange={(e) => handleInputChange(e)}
                            />
                            <div className="vr-edit-count">
                                {`${recordingName?.length}/${maxLength}`}
                            </div>
                        </div>
                        <div className="form-group">
                            <button
                                type="submit"

                                // disabled={!recordingName || load}  // Disable button when recordingName is empty or load is true
                                // disabled={isButtonDisabled || load || !recordingName}
                                disabled={!(recordingName && recordingName.length >= 3) || loading || !(recordingName.trim().length >= 3)}

                                onClick={(e) => {
                                    if (!loading) {  // Only call handalMergeAudio if load is false
                                        handalMergeAudio(e);
                                    }
                                }}
                                className="vr-btn vr-btn-primary vr-btn-block"
                            >
                                {loading ? (
                                    <>
                                        <div
                                            className="spinner-border"
                                            role="status"
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            Save
                                        </span>
                                    </>
                                )
                                }
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default MergeRecordingLogic;
